import { render, staticRenderFns } from "./readPrivacyPolicy.vue?vue&type=template&id=50b0c51c&scoped=true&"
import script from "./readPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./readPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./readPrivacyPolicy.vue?vue&type=style&index=0&id=50b0c51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0c51c",
  null
  
)

export default component.exports